import React, { useEffect, useState } from 'react';
import Header from '../Components/Header';
import { Link } from 'react-router-dom';
import axios from 'axios';

const Customerlist = () => {
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const[customerlist, setCustomerList] = useState([]);
  const [filteredCustomerlist, setFilteredCustomerlist] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 25;
  const totalRecords = filteredCustomerlist.length;
  const totalPages = Math.ceil(totalRecords / recordsPerPage);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  // Calculate records for the current page
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredCustomerlist.slice(indexOfFirstRecord, indexOfLastRecord);

  // Function to change the page
  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  

  
    useEffect (() =>{
      setLoading(true);
    axios.post(`${API_BASE_URL}customer_list.php`)
    .then((response) => {
        if(response.data.head.code === 200){
        setCustomerList(response.data.body)
       /*  console.log(response.data.body); */
       setFilteredCustomerlist(response.data.body)
        }else{
          setCustomerList([])
          setFilteredCustomerlist([])
            console.error("Error Fetching Data",response.data.head.msg)
        }
    })
    .catch((error) =>{
        console.error("API Error:", error);
    })
    .finally(() => {
      setLoading(false);
    });
    },[])

    const [selectedUserId, setSelectedUserId] = useState(null);

    const handleDelete = async () => {
      if (!selectedUserId) {
        alert("Invalid User ID");
        return;
      }
  
     
      try {
        const response = await axios.post(`${API_BASE_URL}customer_list_delete.php`, { user_id: selectedUserId });
  
        if (response.data.head.code === 200) {
        //   alert("Customer deleted successfully!");
         window.location.reload();
        } else {
          alert("Error: " + response.data.head.msg);
        }
      } catch (error) {
        console.error("Delete API Error:", error);
        alert("Failed to delete customer. Please try again.");
      }
    };


    const handleSearch = (e) => {
      const query = e.target.value.toLowerCase();
      setSearchQuery(query);
  
      const searchedOrders = customerlist.filter((customerlist) => {
        return (
          customerlist.name?.toLowerCase().includes(query) ||
          customerlist.agent?.toLowerCase().includes(query) ||
          customerlist.mobile?.includes(query) ||
          customerlist.tax_number?.toLowerCase().includes(query)
        );
      });
  
      setFilteredCustomerlist(searchedOrders);
      setCurrentPage(1);
    };

    return (
        <>
        <Header/>
        <div class="page-wrapper compact-wrapper" id="pageWrapper">
        <div class="page-body-wrapper">
        <div class="page-body">
        
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-sm-12">  
                            <div class="card card-table">
                                <div class="card-body">
                                    <div class="title-header option-title d-sm-flex d-block">
                                        <h5><i class="ri-file-user-fill"></i> List Customer Management</h5>  
                                        <div className="right-options">
                                          <ul>
                
                                            <li>
                                              <Link
                                                className="btn btn-solid"
                                                to="/addcustomer"
                                                // state={{ category_id, subcategory_id }} // pass the id using state
                                              >
                                                Add Customer
                                              </Link>
                                            </li>
                                            <li>
                                              <Link
                                                className="btn btn-solid"
                                                to="/importcustomer"
                                              >
                                                Import Customer     
                                              </Link>
                                            </li>
                                          </ul>
                                        </div>
                                                    
                                        </div>
                                        <div className="row">
                                                    <div className="col-sm-6">
                                                      <form className="theme-form theme-form-2 mega-form">
                                                        <div className="mb-4 row align-items-center">
                                                          <label htmlFor="search" className="col-sm-2 col-form-label">
                                                            Search:
                                                          </label>
                                                          <div className="col-sm-10">
                                                            <input
                                                              type="text"
                                                              id="search"
                                                              name="search"
                                                              className="form-control"
                                                              placeholder="Search"
                                                              value={searchQuery}
                                                              onChange={handleSearch}
                                                            />
                                                          </div>
                                                        </div>
                                                      </form>
                                                    </div>
                                                  </div>
                                                <div>
                                                <div class="table-responsive">
                                                    <table class="table all-package theme-table table-product" id="table_id">
                                                    {loading ? (
                                                <div
                                                  className="d-flex justify-content-center align-items-center"
                                                  style={{ height: "200px" }}
                                                >
                                                  <div
                                                    className="spinner-border text-primary"
                                                    style={{ width: "3rem", height: "3rem" }}
                                                    role="status"
                                                  >
                                                    <span className="visually-hidden">
                                                      Loading...
                                                    </span>
                                                  </div>
                                                </div>
                                              ) : (
                                                <>
                                                <thead>
                                                    <tr>
                                                        <th>S.No.</th>
                                                        <th>Agent</th>
                                                        <th>Customer Name</th>
                                                        
                                                        <th>Mobile</th>
                                                       {/*  <th>Credit Limit</th> */}
                                                        <th>GST Number</th>
                                                        <th style={{ textAlign: 'center' }}>Estimate History</th>
                                                        
                                                        <th style={{ textAlign: 'center' }}>Action</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {currentRecords.length > 0 ? (
                                                        currentRecords.map((item,index) =>(
                                                        <tr key={item.user_id}>
                                                        <td>{indexOfFirstRecord + index + 1}</td>
                                                        <td>{item.agent}</td>
                                                        <td>{item.name}</td>
                                                        
                                                        <td>{item.mobile}</td>
                                                        {/* <td>{item.credit_limit}</td> */}
                                                        <td>{item.tax_number}</td>
                                                        <td style={{ textAlign: 'center' }}>
                                                            <Link to={`/customorderlist/${item.user_id}`}><i class="ri-order-play-fill"></i></Link></td>
														                            <td>
                                                            <ul>                                                               
																                        <li><Link to={`/viewcustomer/${item.user_id}`}><i className="ri-pencil-line"></i></Link></li>
                                                                <li>  <a href="javascript:void(0)" 
                                                                    data-bs-toggle="modal" 
                                                                    data-bs-target="#deleteModal"
                                                                    onClick={() => setSelectedUserId(item.user_id)}>
                                                                    <i className="ri-delete-bin-line"></i>
                                                                </a>
                                                                </li>
                                                            </ul>
                                                        </td>
                                                        
                                                    </tr>
                                                        ))

                                                    ):(
                                                        <tr>
                                                            <td colSpan="5" className="text-center">
                                                            No Record found
                                                            </td>
                                                        </tr>
                                                    )}
                                                    
                                                    <td colSpan="9">
                                                      <table width="100%" border="1" style={{ borderCollapse: "collapse", border: "1px solid #000" }}>
                                                        <tr>
                                                          <td width="20%">Page {currentPage} of {totalPages}</td>
                                                          <td style={{ textAlign: "right" }}>
                                                            {/* Previous Button */}
                                                            {currentPage > 1 ? (
                                                              <a className="pagetext" href="javascript:void(0);" onClick={() => paginate(currentPage - 1)}>
                                                                &laquo; Previous
                                                              </a>
                                                            ) : (
                                                              <span>&laquo; Previous</span>
                                                            )}
                                                            &nbsp;
                                                            {/* Page Numbers */}
                                                            {[...Array(totalPages)].map((_, i) => (
                                                                <React.Fragment key={i}>
                                                                  <a
                                                                    className={`pagetext ${currentPage === i + 1 ? "active" : ""}`}
                                                                    href="javascript:void(0);"
                                                                    onClick={() => paginate(i + 1)}
                                                                  >
                                                                    {i + 1}
                                                                  </a>
                                                                  &nbsp;
                                                                </React.Fragment>
                                                              ))}

                                                            {/* Next Button */}
                                                            {currentPage < totalPages ? (
                                                              <a className="pagetext" href="javascript:void(0);" onClick={() => paginate(currentPage + 1)}>
                                                                Next &raquo;
                                                              </a>
                                                            ) : (
                                                              <span>Next &raquo;</span>
                                                            )}

                                                            {/* Last Button */}
                                                            {currentPage < totalPages ? (
                                                              <a className="pagetext" href="javascript:void(0);" onClick={() => paginate(totalPages)}>
                                                                Last &raquo;&raquo;
                                                              </a>
                                                            ) : (
                                                              <span>Last &raquo;&raquo;</span>
                                                            )}
                                                          </td>
                                                        </tr>
                                                      </table>
                                                    </td>
                                              </tbody>
                                                </>
                                              )}
                                            </table>											
                                        </div>
										
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
            </div>
            </div>
            <div className="modal fade" id="deleteModal" tabIndex="-1" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Confirm Delete</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              Are you sure you want to delete this customer?
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                Cancel
              </button>
              <button type="button" className="btn btn-danger" onClick={handleDelete} >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
        </>
    );
};

export default Customerlist;
